import { render, staticRenderFns } from "./NotaHogarTablaComponent.vue?vue&type=template&id=45e771b7&scoped=true&"
import script from "./NotaHogarTablaComponent.vue?vue&type=script&lang=js&"
export * from "./NotaHogarTablaComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotaHogarTablaComponent.vue?vue&type=style&index=0&id=45e771b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e771b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VLayout,VRow,VSelect,VSheet})
